import { getLiveStatus } from './liveHours.js';

const status = getLiveStatus();

document.querySelectorAll('[data-live-line]').forEach((el) => {
  el.textContent = status.line;
});

if (status.live) {
  document.querySelectorAll('[data-live-cta]').forEach((el) => {
    el.textContent = 'Practice speaking now';
  });
}
